import React, { ReactNode } from 'react';
import type { Column } from 'react-table';

export type TableData = {
  lastName: string;
  firstName: string;
  middleInitial?: string;
  phoneNumber: string;
  emailAddress: string;
  mouSignatory: string;
  admin: string;
  actions: ReactNode;
};

export const columns: Column<TableData>[] = [
  {
    Header: 'Last Name',
    accessor: 'lastName',
    width: 100,
  },
  {
    Header: 'First Name',
    accessor: 'firstName',
    width: 100,
  },
  {
    Header: 'M.I.',
    accessor: 'middleInitial',
    width: 50,
  },
  {
    Header: 'Phone Number',
    accessor: 'phoneNumber',
    width: 110,
  },
  {
    Header: 'Email Address',
    accessor: 'emailAddress',
    width: 160,
  },
  {
    Header: 'Signatory',
    accessor: 'mouSignatory',
    width: 110,
  },
  {
    Header: 'Program Admin',
    accessor: 'admin',
    width: 110,
  },
  {
    Header: <span className="usa-sr-only">Actions</span>,
    accessor: 'actions',
    width: 50,
  },
];
